import React, { FC, useMemo, useState } from 'react';
import './TrainingGoalStep.scss';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';
import { ReactComponent as Increase_strengthIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/increase_strength.svg';
import { ReactComponent as Injury_preventionIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/injury_prevention.svg';
import { ReactComponent as General_fitnessIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/general_fitness.svg';
import { ReactComponent as RehabilitationIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/rehabilitation.svg';
import { ReactComponent as Build_muscleIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/build_muscle.svg';
import { ReactComponent as Weight_lossIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/weight_loss.svg';
import { ReactComponent as PerformanceIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/performance.svg';
import { ReactComponent as EnduranceIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/endurance.svg';
import { ReactComponent as MobilityIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/mobility.svg';

interface TrainingGoalStepProps {
  value?: string;
  onNext?: (goalId: string) => void;
}

const iconMapping: Record<string, any> = {
  increase_strength: <Increase_strengthIcon />,
  build_muscle: <Build_muscleIcon />,
  weight_loss: <Weight_lossIcon />,
  endurance: <EnduranceIcon />,
  mobility: <MobilityIcon />,
  performance: <PerformanceIcon />,
  general_fitness: <General_fitnessIcon />,
  rehabilitation: <RehabilitationIcon />,
  injury_prevention: <Injury_preventionIcon />,
};

// What is the training goal?
export const TrainingGoalStep: FC<TrainingGoalStepProps> = ({ value, onNext }) => {
  const [selectedGoal, setSelectedGoal] = useState<string>(value || '');

  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();
  const trainingGoal = programMasterData?.trainingGoal;
  const options = trainingGoal?.options;

  const goalOptions = useMemo(() => {
    if (!options) return [];
    return [...options].sort((a, b) => (a.order || 0) - (b.order || 0));
  }, [options]);

  if (isLoading) {
    return <div className="training-goal-step">{'Loading options...'}</div>;
  }

  if (isError || !trainingGoal) {
    return <div className="training-goal-step">{'Error loading options.'}</div>;
  }

  return (
    <div className="training-goal-step">
      <h2 className="step-title">{trainingGoal.title}</h2>
      {trainingGoal.subtitle && <p className="step-subtitle">{trainingGoal.subtitle}</p>}

      <div className="goal-buttons">
        {goalOptions.map((goal) => (
          <button
            key={goal.id}
            className={`goal-btn ${selectedGoal === goal.slug ? 'selected' : ''}`}
            onClick={() => {
              setSelectedGoal(goal.slug);
              if (onNext) onNext(goal.slug);
            }}
          >
            <div className="goal-icon">{iconMapping[goal.id]}</div>
            <span className="goal-label">{goal.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
